module.exports = __webpack_public_path__ + "static/media/17-MaxWealth.40ce9c6e.png";